import axios from "axios";
const API_URL = "https://ims.holdthechild.net"; // Update with your actual API URL
export const getToken = () => localStorage.getItem("token");


// Function to register a new staff member
export const addStaff = async (formData) => {
  try {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/staff/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Add this if your API needs it
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.msg || "Failed to add staff");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const bulkAddStaff = async (staffList) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${API_URL}/api/staff/bulk-add`,
      { staffList },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get staff for table
// (Removed duplicate getStaff function to avoid redeclaration error)



// Get one staff by ID
export const getOneStaff = async (id) => {
  try {
    const token = localStorage.getItem("token");

    if (!token) throw new Error("No token found in localStorage");

    const res = await fetch(`${API_URL}/api/staff/${id}/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Fetch failed response:", data);
      throw new Error(data.message || "Failed to fetch staff");
    }

    return data; // Return fetched data to the caller
  } catch (error) {
    console.error("getOneStaff error:", error);
    throw error;
  }
};


// Update profile
export const updateStaff = async (id, updatedStaff) => {
  const token = localStorage.getItem('token');  // <-- here, just before the fetch

  if (!token) {
    throw new Error("No token found, please log in");
  }

  const res = await fetch(`${API_URL}/api/staff/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,  // use it here
    },
    body: JSON.stringify(updatedStaff),
  });

  const data = await res.json();
   

  if (!res.ok) {
    throw new Error(data.message || "Failed to update staff");
  }

  return data;
};


export const getStaff = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!token) throw new Error("No token found in localStorage");

    const res = await fetch(`${API_URL}/api/staff/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Fetch failed response:", data);
      throw new Error(data.message || "Failed to fetch staff");
    }

    // Safe structure
    return {
      raw: data,
      list: Array.isArray(data.data)
        ? data.data
        : Array.isArray(data.data?.staff)
        ? data.data.staff
        : [],
    };
  } catch (err) {
    console.error("Get staff error:", err.message);
    throw err;
  }
};


export const getStaff1 = async (searchQuery = "") => {
  try {
    const token = localStorage.getItem("token");

    if (!token) throw new Error("No token found in localStorage");
    
    // 1. Construct the URL with the search query
    const url = new URL(`${API_URL}/api/staff/`);
    if (searchQuery) {
        url.searchParams.append("search", searchQuery);
    }
    
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("Fetch failed response:", data);
      throw new Error(data.message || "Failed to fetch staff");
    }

    // 2. Adjust the return structure to directly access the staff list
    // The backend returns a `data` key that contains the staff list (`docs`).
    return data.data; // Return the `docs` array directly.
  } catch (err) {
    console.error("Get staff error:", err.message);
    throw err;
  }
};
